import React, { useEffect, useState } from "react";
import CheckboxOn from "../../../assets/images/CheckboxOn.svg";
import CheckboxOff from "../../../assets/images/CheckboxOff.svg";
import Imagebrand from "../../../assets/images/imag.svg";
import Afribrand from "../../../assets/images/afriglobal.svg";
import Lancetbrand from "../../../assets/images/lancet.svg";
import Dnabrand from "../../../assets/images/dna.svg";
import Clinixbrand from "../../../assets/images/clinix.svg";
import Accunalysisbrand from "../../../assets/images/accunalysis.svg";
import Synlabbrand from "../../../assets/images/synlab.svg";
import Echobrand from "../../../assets/images/echo.svg";
import Mecurebrand from "../../../assets/images/mecure.svg";
import Docbrand from "../../../assets/images/docbrand.svg";
import Unionbrand from "../../../assets/images/union.svg";
import DropDown from "../../../components/Select";
import ArrowDown from "../../../assets/images/arrowDown.svg";
import DownYellow from "../../../assets/images/downYellow.svg";
import BrandImage from "../../../assets/images/brandImage.svg";
import ECHOLAB from "../../../assets/images/logos1.svg";
import Synlab from "../../../assets/images/logos4.svg";
import DeleteRounded from "../../../assets/images/deleteRounded.svg";
import Dropdown from "react-dropdown";
import { Toast } from "../../../components";
import axios from "axios";
import ShoppingCartIndividualTest from "./ShoppingCartIndividualTest";

function ShoppingCartLabWise(props) {
  let {
    selectRecipient,
    showRecipient,
    setShowRecipient,
    totalRecipient,
    showHomeService,
    i,
    homeService,
    cityList,
    areaList,
    // mobileView,
    index,
    radiovalue,
    recipientArray,
    addressForm,
    editForm,
    edit,
    qtyValue,
    delivery,
    datatwo,
    showAddAddress,
    addHomeAddress,
  } = props;

  const [checked, setChecked] = useState(false);
  const [selectAllTestsInLab, setSelectAllTestsInLab] = useState(false);
  const [errName, setErrName] = useState("");
  const [errorPop, setErrorPop] = useState(false);
  const [checkedState, setCheckedState] = useState();

  const [selected, setSelected] = useState("");
  const [selectedIndex, setSelectedIndex] = useState("");
  const [editAddres, setEditAddress] = useState(true);
  const [homeAddres, setHomeAddress] = useState("");

  const [mobileView, setMobileView] = useState(false);
  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 768
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  const handleAddressSelection = (ad, index) => {
    setSelected("Selected");
    setSelectedIndex(index);
    setHomeAddress(ad);
    addHomeAddress(ad);
  };

  useEffect(() => {
    setCheckedState(new Array(i.data).fill(false));
  }, [i.data]);

  useEffect(() => {
    try {
      if (selectAllTestsInLab === true) {
        if (checkedState.includes(false)) {
          setSelectAllTestsInLab(false);
        }
      } else {
        if (!checkedState.includes(false)) {
          setSelectAllTestsInLab(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [checkedState, selectAllTestsInLab]);

  const handleOnChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );

    props.handleRadio(i.data[position].uuid, i.data[position]);
    setCheckedState(updatedCheckedState);
  };

  const handleAllFunction = (e, index) => {
    if (i.data) {
      let labTests = i.data,
        flag = false;
      for (let obj of labTests) {
        if (obj && obj.patient_uuid && obj.patient_uuid != "") {
        } else {
          if (obj.name !== "Home Service Charge") {
            flag = true;
          }
        }
      }

      let items = [];
      i.data.map((item) => {
        if (item.name !== "Home Service Charge") {
          items.push(item);
        }
      });

      if (e.target.checked === true) {
        setCheckedState(new Array(i.data.length).fill(true));
        setSelectAllTestsInLab(e.target.checked);
        props.handleAllFunction(index);
      } else {
        setCheckedState(new Array(i.data.length).fill(false));

        setSelectAllTestsInLab(e.target.checked);
        props.handleAllFunction(index);
      }
    }
  };

  useEffect(() => {
    let tests = i.data,
      flag,
      count = 0;
    if (radiovalue && radiovalue.length > 0) {
      for (let j of radiovalue) {
        for (let k of tests) {
          if (j.uuid == k.uuid) {
            if (k.name !== "Home Service Charge") {
              flag = true;
            }
            count = count + 1;
          }
        }
      }
      if (!flag && checked) {
        setChecked(false);
        homeService.map((item, hmIndex) => {
          if (item.labname === i.labname && item.areaname === i.labarea) {
            props.handleRadio(item.uuid, item);
          }
        });
      }
      if (tests && tests.length !== count) {
        setSelectAllTestsInLab(false);
      }
    }
  }, [radiovalue]);

  const handleRadio = (e, uuid, item) => {
    let tests = i.data,
      flag;
    for (let j of radiovalue) {
      for (let k of tests) {
        if (j.uuid == k.uuid && k.name !== "Home Service Charge") {
          flag = true;
          setChecked(e.target.checked);
          props.handleRadio(uuid, item);
          break;
        }
      }
    }
    if (!flag) {
      setErrorPop(true);
      setErrName("Select atleast one test");
    }
  };

  const renderCheckBox = (index, ind) => {
    try {
      return (
        <div>
          <input
            style={{ marginTop: "1%", marginLeft: "26px" }}
            type="checkbox"
            name="selectTest"
            onChange={() => handleOnChange(ind)}
            value={index}
            checked={checkedState[ind]}
          />
        </div>
      );
    } catch (error) {
      console.log(error);
    }
  };


  const [partner, setPartner] = useState([]);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/metadata/partner/getpartner`)
      .then((res) => {
        setPartner(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  var array3 = [];

  for (var i1 = 0; i1 < partner.length; i1++) {
    if (partner[i1].uuid === i.data[0].partner_uuid) {
      array3.push(partner[i1]);

    }
  }
  console.log(array3, "partner[i]");

  console.log(i.data[0], "item.data[0]")
  // uuid
  return (
    <>
      <div className="location-row-out" key={index}>
        {/* <img
          src={
            i.data[0].lab_partner_name === "ECHOLAB"
              ? ECHOLAB
              : i.data[0].lab_partner_name === "UNION DIAGNOSTICS"
                ? BrandImage
                : i.data[0].lab_partner_name === "SYNLAB"
                  ? Synlab
                  : i.data[0].lab_partner_name === "IMAGE DIAGNOSTICS"
                    ? Imagebrand
                    : i.data[0].lab_partner_name === "DNA LABS"
                      ? Dnabrand
                      : i.data[0].lab_partner_name === "CLINIX"
                        ? Clinixbrand
                        : i.data[0].lab_partner_name === "CLINA LANCET"
                          ? Lancetbrand
                          : i.data[0].lab_partner_name === "AFRIGLOBAL"
                            ? Afribrand
                            : null
          }
          alt="BrandImage"
        /> */}
        {array3.map((item) => {
          return <img src={item.logo} style={{ width: "150px", height: "auto", paddingLeft: "10px" }}></img>;
        })}
        {!mobileView ? (
          <div className="location-cont">
            <div className="left-cont">Location</div>
            <div className="right-cont-out">
              <div className="left-cont" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                City:
                {i.data && i.data[0] && i.data[0].tests.city}
              </div>
              <div className="left-cont">
                Area:
                {i.data && i.data[0] && i.data[0].tests.area}
              </div>
              {/* <div className="left-cont">
                  <div  style={{ color: "#163e8c", alignItems: "right" }}><b>EDIT</b></div>
                </div> */}
            </div>
          </div>
        ) : (
          <>
            <div className="location-cont">
              <div className="left-cont">Location</div>
              <div className="right-cont-out">
                <div className="left-cont" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  City:
                  {i.data && i.data[0] && i.data[0].tests.city}
                </div>
                <div className="left-cont">
                  Area:
                  {i.data && i.data[0] && i.data[0].tests.area}
                </div>
                {/* <div className="left-cont">
                  <div  style={{ color: "#163e8c", alignItems: "right" }}><b>EDIT</b></div>
                </div> */}
              </div>
            </div>
          </>
        )}
      </div>

      <div className="selected-test-container-out">
        <div className="selected-test-container">
          {mobileView == false ? (
            <>
              <div className="top-header-row-out">
                <div className="start-grp col-md-4">
                  <>
                    <input
                      id="test"
                      type="checkbox"
                      name="cheapestCompareProduct"
                      onChange={(e) => handleAllFunction(e, index)}
                      value={index}
                      checked={selectAllTestsInLab}
                      style={{ marginRight: "10%", marginBottom: "4%"}}
                    />
                  </>
                  {/* <div className="" >DIAGNOSTIC TEST</div> */}
                  <div className=""   style={{fontWeight:"bold !important"}}>DIAGNOSTIC TEST</div>
                </div>

                {/* <div className="col-md-2">QUANTITY</div>
                <div className="col-md-2">AMOUNT</div>
                <div className="col-md-4">WHO IS THE TEST FOR?</div> */}

                <div className="col-md-2"  style={{fontWeight:"bold !important",paddingLeft:"20px"}}>QUANTITY</div>
                <div className="col-md-2"  style={{fontWeight:"bold !important",paddingLeft:"20px"}}>AMOUNT</div>
                <div className="col-md-4"  style={{fontWeight:"bold !important",paddingLeft:"10px"}}>WHO IS THE TEST FOR?</div>
              </div>
              {console.log(i, "sk")}
              {i.data.map((val, ind) => {
                console.log(val, "sk")
                // if (val.name !== "Home Service Charge") {
                return (
                  <>
                    <div className="indivial_select">
                      {renderCheckBox(index, ind)}

                      <ShoppingCartIndividualTest
                        i={i}
                        key={ind}
                        ind={ind}
                        val={val}
                        recipientArray={recipientArray}
                        radiovalue={radiovalue}
                        handleRadio={props.handleRadio}
                        handleChangeRecipient={props.handleChangeRecipient}
                      />
                    </div>
                    <div className="inner-divider-shop"></div>
                  </>
                );
                // }
              })}

              {/* <div className="grp-divider"></div> */}
            </>
          ) : (
            <>
              <div className="top-header-row-out">
                {/* <div className="start-grp"> */}
                  <div className="font-class">DIAGNOSTIC TEST</div>
                  <div className="font-class">AMOUNT</div>
                {/* </div> */}
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  padding: "15px",
                  marginLeft:"3%"
                }}
              >
                <input
                  type="checkbox"
                  name="cheapestCompareProduct"
                  onChange={(e) => handleAllFunction(e, index)}
                  value={index}
                  checked={selectAllTestsInLab}
                  style={{ marginRight: "20px" }}
                />
                <span className="custom_checkbox"></span>
                <span>All</span>
              </div>
              <div className="inner-divider-shop"></div>
              {i.data.map((val, ind) => {
                // if (val.name !== "Home Service Charge") {
                return (
                  <>
                    <div className="indivial_select">
                      <div
                        style={{ alignSelf: "flex-start", marginTop: "35px" }}
                      >
                        {renderCheckBox(index, ind)}.
                      </div>

                      <ShoppingCartIndividualTest
                        i={i}
                        key={ind}
                        ind={ind}
                        val={val}
                        recipientArray={recipientArray}
                        radiovalue={radiovalue}
                        handleRadio={props.handleRadio}
                        handleChangeRecipient={props.handleChangeRecipient}
                        mobileview={mobileView}
                      />
                    </div>
                    {/* <div className="inner-divider-shop"></div> */}
                  </>
                );
                // }
              })}

              {/* <div className="grp-divider"></div> */}
            </>
          )}
        </div>
      </div>
      <div className="divider-part"></div>

      <Toast
        text={errName}
        type="warning"
        open={errorPop}
        setClose={() => {
          setErrorPop(false);
        }}
      />
    </>
  );
}

export default ShoppingCartLabWise;
